/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import Dphoto from "../../Images/profile-default.png";
import { showTost } from '../../showTost';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
const Profile = () => {

  const { t } = useTranslation();

  const { BaseUrl } = useContext(MyContext);
  const [Data, setData] = useState();
  const [profilePic, setProfilePic] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const InputRef = useRef();

  useEffect(() => {
    const loginId = localStorage.getItem("Userid");

    const handleProfiledata = async () => {
      if (!loginId) {
        return;
      }

      try {
        const res = await axios.get(`https://yblapis.ganpatigroupbharat.com/api/auth/getuserdetailByLoginId?loginId=${loginId}`);

        if (res.data?.isSuccess === true) {
          setData({
            loginId,
            name: res.data?.data?.name,
            email: res.data?.data?.email,
            mobileNo: res.data?.data?.mobileNo,
            referralCode: res.data?.data?.referralCode,
            referralCount: res.data?.data?.referralCount,
          });

          if (res.data?.data?.imagePath) {
            setProfilePic(`https://yblapis.ganpatigroupbharat.com/${res.data?.data?.imagePath}`);
          }
        }
      } catch (error) {
        console.log("Server error", "error");
      }
    };

    handleProfiledata();
  }, []);

  const handleUpdatePassword = async () => {
    if (!newPassword) {
      showTost("Please enter password", "error");
      return;
    }

    if (newPassword.length < 4) {
      showTost("Password must be at least 6 characters", "error");
      return;
    }

    const formData = new FormData();
    formData.append("loginId", Data?.loginId);
    formData.append("name", Data?.name);
    formData.append("emailId", Data?.email);
    formData.append("mobileNo", Data?.mobileNo);
    formData.append("password", newPassword);

    try {
      const res = await axios.post(
        "https://yblapis.ganpatigroupbharat.com/api/auth/updateprofilebyloginid",
        formData
      );

      if (res.data?.status === true) {
        showTost("Password updated successfully", "success");
        setNewPassword("");
      } else {
        showTost(res.data?.message || "Update failed", "error");
      }
    } catch (error) {
      showTost("Server error", "error");
    }
  };

  /* ---------------- IMAGE SELECT ---------------- */
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setProfilePic(URL.createObjectURL(file));
    }
  };

  /* ---------------- IMAGE UPLOAD ---------------- */
  const handleAddPhoto = async () => {
    if (!selectedFile) {
      showTost("Please select image", "error");
      return;
    }

    const formData = new FormData();
    formData.append("loginId", Data?.loginId);
    formData.append("name", Data?.name);
    formData.append("emailId", Data?.email);
    formData.append("mobileNo", Data?.mobileNo);
    formData.append("file", selectedFile);

    try {
      const res = await axios.post(
        "https://yblapis.ganpatigroupbharat.com/api/auth/updateprofilebyloginid",
        formData
      );

      if (res.data?.status === true) {
        showTost("Profile image updated", "success");
        setIsShow(false);
      } else {
        showTost("Image upload failed", "error");
      }
    } catch (error) {
      showTost("Server error", "error");
    }
  };

  return (
    <div className='width_container'>
      <div className="mt-[20px]">
        <div className="profile">

          <div className="profile_pic">
            <img src={profilePic ? profilePic : Dphoto} className='w-[150px] h-[150px] object-cover rounded-[100%]' alt="" />
            <div onClick={() => setIsShow(true)} className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-pencil-minus"><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path><path d="M13.5 6.5l4 4"></path><path d="M16 19h6"></path></svg>
            </div>
          </div>

          <div className="mt-[20px]">
            <input disabled type="text" value={Data?.name} onChange={(e) => setData({ ...Data, name: e.target.value })} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px] text-white' placeholder={t('Enter Name')} />
            {/* <input type="text" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px]' placeholder={t('Enter Password')} /> */}
            <input disabled type="text" value={Data?.email} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px] text-white' />
            <input disabled type="text" value={Data?.mobileNo} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px] text-white' />
            {/* <input disabled type="text" value={Data?.referralCode ? `ReferralCode : ${Data?.referralCode}` : "ReferralCode : N/A"} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px]' /> */}
            {/* <input disabled type="text" value={Data?.referralCount > 0 ? `Referral Count : ${Data?.referralCount}` : "Referral Count : 0"} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px]' /> */}

            <div className='mt-[12px] flex justify-between'>
              <h4 className='text-white'>{Data?.referralCode ? `ReferralCode : ${Data?.referralCode}` : "ReferralCode : N/A"}</h4>
              <h4 className='text-white'>{Data?.referralCount > 0 ? `Referral Count : ${Data?.referralCount}` : "Referral Count : 0"}</h4>
            </div>
          </div>

          {/* <button onClick={handleUpdatePassword} className='button'>{t("Update")}</button> */}

        </div>
      </div>

      {isShow && <div onClick={() => setIsShow(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="w-[25%] max-_430_:w-[100%] max-_768_:w-[80%] max-_1030_:w-[40%] max-_1500_:w-[30%] bg-white rounded-[15px] px-[15px] py-[10px]">
          <div className="flex flex-col justify-center items-center text-center">
            <div onClick={() => InputRef.current.click()} className="w-[138px] cursor-pointer border-[2px] border-dotted p-[10px] border-gray-400 rounded-full">
              <div className="bg-[#e5e5e5] flex items-center justify-center h-[115px] rounded-full">
                {selectedFile
                  ? <img src={`data:image/png;base64,${selectedFile}`} className="w-[100%] h-[100%] rounded-full object-center" alt="" />
                  : <h2 className="m-0 font-[400] text-[30px]">+</h2>}

                <input ref={InputRef} onChange={(e) => handleImageChange(e)} className="hidden" type="file" accept="image/*" />
              </div>
            </div>
            <div className="mt-[15px]">
              <h3 className='font-bold text-[20px]'>{t("Add Your Favorite Photo")}</h3>
            </div>
            <button onClick={handleAddPhoto} className="button">{t("Upload")}</button>
          </div>
        </div>
      </div>}
    </div >
  )
}

export default Profile
/* jshint ignore:end */